import { axiosInstance, getRequest, postRequest, putRequest } from "./apiService";

export const createProgram = (program) => {
    return postRequest("/programs", program).then((response) => response.data);
}

export const updateProgram = (program) => {
    return putRequest(`programs/${program.id}`, program).then((response) => response.data);
}

export const getPrograms = (id) => {
    //PATCH, TODO we will use this for now, until we have the filters applied
    if(id) {
        return getRequest("/programs").then((response) => {
            return response.data.filter((x) => {
                return x.id == id;
            })
        });
    } else {
        return getRequest("/programs" + (id ? `/${id}` : "")).then((response) => response.data);
    }
}